
import { ETMFAPI, ETMFUI } from 'src/types/KeyCloak';
import { TabsType } from 'src/types/TabsType';
import { Viewer } from '../modelviewer/Viewer';
import { DocumentUpload } from './documentUpload/DocumentUpload';
import RecentDocuments from './documentViewer/RecentDocuments';
import LandingViewContainer from './landing/LandingViewContainer';
import MilestoneTracking from './milestoneTracking/MilestoneTracking';
import ModelViewerComponent from './modelViewer/ModelViewerComponent';
import PlanningComponent from './planning/PlanningComponent';
import SearchComponent from './search/SearchComponent';
import TasksComponent from './tasks/TasksComponent';


export const TabsData: TabsType = [
    {
        key: 'landingPage',
        index: 0,
        enabled: true,
        component: LandingViewContainer,
        permissions: ETMFUI.VIEW_LANDING_PAGE
    },
    {
        index: 1,
        key: 'search',
        enabled: true,
        component: SearchComponent,
        permissions: ETMFUI.SEARCH_DOCUMENTS
    },
    {
        index: 2,
        key: 'milestoneTracking',
        enabled: true,
        component: MilestoneTracking,
        permissions: ETMFUI.VIEW_SITE_MILESTONES
    },
    {
        index: 3,
        enabled: true,
        key: 'planning',
        component: PlanningComponent,
        permissions: ETMFUI.VIEW_PLANNING
    },
    {
        index: 4,
        enabled: true,
        key: 'documentUpload',
        component: DocumentUpload,
        permissions: ETMFUI.UPLOAD_DOCUMENTS
    },
    {

        index: 5,
        enabled: true,
        key: 'documentViewer',
        component: RecentDocuments,
        permissions: ETMFUI.VIEW_UPLOADED_DOCUMENTS
    },
    {
        index: 6,
        enabled: true,
        key: 'tasks',
        component: TasksComponent,
        permissions: ETMFUI.VIEW_TASKS

    },
    // {
    //     index: 7,
    //     enabled: true,
    //     key: 'tmfModelViewer',
    //     component: ModelViewerComponent,
    //     permissions: ETMFAPI.CREATE_FILE_COMMENTS
    // },
    {
        index: 7,
        enabled: true,
        key: 'tmfModelViewer',
        component: Viewer,
        permissions: ETMFUI.VIEW_TMF_BINDER_VIEWER
    }
];


export const TabsRoutesInfo = [
    'landingPage',
    'search',
    'documentUpload',
    'documentViewer',
    'tmfModelViewer',
    'tasks'
    // 'tmfModelViewer_refactor'
];

export const defaultTabKey = 'landingPage';

export const documentViewerKey = 'documentViewer';
